import React from "react";
import ServiceDetail from "@/pages/services/ServiceDetail";

const Dryer = () => <ServiceDetail slug="dryers" />;
export default Dryer;
